import React from 'react';
import { Button } from 'react-bootstrap';
import { IRouteButtonProps } from './types';
import { useHistory } from 'react-router-dom';

export const RouteButton: React.FC<
  IRouteButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ to, replace, children, ...rest }) => {
  const history = useHistory();

  const handleClick = () => {
    if (replace) {
      history.replace(to);
    } else {
      history.push(to);
    }
  };

  return (
    <Button type="button" onClick={handleClick} {...rest}>
      {children}
    </Button>
  );
};
